import { useQuery } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import ValidatedSelect from '../../common/forms/ValidatedSelect';

export const Customer = ({ disabled = false }) => {
    const { data, isLoading } = useQuery({
        queryKey: ['accessibleCustomers'],
        queryFn: () => httpClient.js(ApiRoutes.typeAheads.accessibleCustomers()),
    });

    return (
        <ValidatedSelect
            id="customerCompanyId"
            name="customerCompanyId"
            options={data}
            isLoading={isLoading}
            label="Which customer are these job requests for?"
            required
            error="You must select a customer"
            disabled={disabled}
        />
    );
};
